import plugin from "@company-mrv/mrv-plugins-sensia";

export default plugin;
